/**
 * Height of the app's horizontal top bars: the top navigation bar, the
 * sidebar header, drawer top bars and the chat panel header.
 *
 * They all draw their 1px bottom border *inside* this height (border-box),
 * so keeping them on a single constant keeps the lines pixel-aligned across
 * the sidebar, the main content and any open drawer or panel.
 */
export const TOP_BAR_HEIGHT = 52;

/**
 * Min-width media queries matching the legacy react-system breakpoints
 * (768px and 1280px), kept identical so migrated layout code renders
 * pixel-for-pixel the same.
 */
export const MEDIA_TABLET = '@media screen and (min-width: 48em)';
export const MEDIA_DESKTOP = '@media screen and (min-width: 80em)';

/**
 * Single source of truth for page-level content padding: tight on phones,
 * roomier from tablet up. Spread into the page container's `sx`.
 */
export const pagePaddingSx = {
  px: { xs: 1, sm: 2, lg: 3 },
  py: { xs: 1, sm: 3 },
} as const;

/**
 * Single source of truth for the topbar page-title typography: bold, compact
 * on phones, full h6 (20px) from tablet up. Works in both `css` and `sx`
 * props.
 */
export const pageTitleTypographySx = {
  fontSize: 16,
  fontWeight: 700,
  [MEDIA_TABLET]: { fontSize: 20 },
} as const;
